module.exports = __webpack_public_path__ + "85312d3fdc6a4066da6a326b7d711eb5.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-company-user-label/sp-company-user-label.html
// module id = 1064
// module chunks = 0